import { useMemo, useState } from "react";
import { CASES, INDUSTRY_FILTERS, SERVICE_FILTERS } from "../data/cases";
import CaseCard from "./CaseCard";

// 実績一覧の絞り込み（サービス × 業種）。タグに含まれるかで判定する。
function FilterBar({ label, options, value, onChange }) {
  return (
    <div className="filter-bar">
      <span className="filter-label">{label}</span>
      <button
        type="button"
        className={value === null ? "is-active" : undefined}
        aria-pressed={value === null}
        onClick={() => onChange(null)}
      >
        すべて
      </button>
      {options.map((o) => (
        <button
          type="button"
          key={o}
          className={value === o ? "is-active" : undefined}
          aria-pressed={value === o}
          onClick={() => onChange(o)}
        >
          {o}
        </button>
      ))}
    </div>
  );
}

export default function CasesBrowser() {
  const [service, setService] = useState(null);
  const [industry, setIndustry] = useState(null);

  const list = useMemo(
    () =>
      CASES.filter(
        (c) =>
          (!service || c.tags.includes(service)) &&
          (!industry || c.tags.includes(industry)),
      ),
    [service, industry],
  );

  return (
    <>
      <FilterBar
        label="サービス"
        options={SERVICE_FILTERS}
        value={service}
        onChange={setService}
      />
      <FilterBar
        label="業種"
        options={INDUSTRY_FILTERS}
        value={industry}
        onChange={setIndustry}
      />
      <div className="case-grid case-grid-page">
        {list.map((c) => (
          <CaseCard key={c.slug} c={c} />
        ))}
        {list.length === 0 && (
          <p className="case-empty">該当する実績はまだありません。</p>
        )}
      </div>
    </>
  );
}
